import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvestmentsRoutingModule } from './investments-routing.module';
import { ToggleSwitchModule } from 'src/app/shared/toggle-switch/toggle-switch.module';
import { InvestmentDetailComponent } from 'src/app/pages/investment-detail/investment-detail.component';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ModelStrategyCarouselModule } from 'src/app/shared/model-strategy-carousel/model-strategy-carousel.module';
import { DropdownListModule } from 'src/app/shared/dropdown-list/dropdown-list.module';
import { InstrumentChartCarouselModule } from 'src/app/shared/charts/instrument-chart-carousel/instrument-chart-carousel.module';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { DropdownModule } from 'src/app/shared/dropdown/dropdown.module';
import { TooltipButtonModule } from 'src/app/shared/tooltip-button/tooltip-button.module';
import { ChartsModule } from 'src/app/shared/charts/charts.module';
import { PricePipeModule } from 'src/app/pipes/price.module';
import { CurrencyDigitShortcutPipeModule } from 'src/app/pipes/currency-digit-shortcut-pipe.module';
import { InvestmentFrequencyPipeModule } from 'src/app/pipes/investment-frequency-pipe.module';
import { DaysDiffPipeModule } from 'src/app/pipes/days-diff-pipe.module';
import { DraftCommentaryComponent } from 'src/app/shared/draft-commentary/draft-commentary.component';
import { DescriptionDropdownModule } from 'src/app/shared/description-dropdown/description-dropdown.module';

@NgModule({
  declarations: [
    InvestmentDetailComponent,
    DraftCommentaryComponent,
  ],
  imports: [
    CommonModule,
    ToggleSwitchModule,
    InvestmentsRoutingModule,
    PreloadSpinnerModule,
    TranslateModule,
    AngularSvgIconModule,
    ModelStrategyCarouselModule,
    DropdownListModule,
    InstrumentChartCarouselModule,
    ButtonModule,
    DropdownModule,
    TooltipButtonModule,
    ChartsModule,
    PricePipeModule,
    CurrencyDigitShortcutPipeModule,
    InvestmentFrequencyPipeModule,
    DaysDiffPipeModule,
    DescriptionDropdownModule,
  ],
  exports: [
    InvestmentDetailComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class InvestmentsModule { }
